import { DocumentsOperations } from "constant-data/documentsData";

export const MENU_CONFIG = [
  { icon: "home", name: "Главная", path: "/" },
  {
    icon: "reference",
    name: "Справочники",
    path: "references/",
    children: [
      { name: "Товары", path: "/references/products" },
      { name: "Шаблоны для печати", path: "/references/print-templates" },
      { name: "Шаблоны чеков", path: "/references/cheque-print-templates" },
      { name: "Склады/Магазины", path: "/references/stock" },
      { name: "Станции", path: "/references/stations" },
      { name: "Сотрудники", path: "/references/employees" },
      { name: "Клиенты", path: "/references/clients" },
      { name: "Статьи затрат", path: "/references/expenses" },
      { name: "Прайслисты", path: "/references/prices" },
    ],
  },
  {
    icon: "coins",
    name: "Маркетинг",
    path: "marketing/",
    children: [
      { name: "Скидки", path: "/marketing/discounts" },
      { name: "Акции", path: "/marketing/promotions" },
    ],
  },
  {
    icon: "documents",
    name: "Документы",
    path: "documents/",
    children: DocumentsOperations.filter((i) => i.include).map((i) => ({
      name: i.name,
      path: `/documents/${i.id}`,
    })),
  },
  {
    icon: "box",
    name: "Отчёты складские",
    path: "reports",
    children: [
      { name: "Движение товаров", path: "/reports/movement" },
      { name: "Отчёт по прибыли", path: "/reports/profit" },
    ],
  },
];
